import { FormFieldSettings } from "../../form-settings/form-field-settings";
import { ParentFieldFactory } from "../field-factory";
import { DynamicController } from "../dynamic-controller";
import { ArrayFormFieldSetting } from "./array-form-field-setting";
import { FormFieldArrayComponent } from "./form-field-array-component";
import { FormRootDirective } from "../../form/form-root.directive";
import { Paginator, PageEvent } from "./paginator";
import { Subscription } from "rxjs";
import { FormContext } from "../../form/form-context";
import { ArrayRenderer } from "./array-renderer";
import { FormArray } from "@angular/forms";

export class DynamicArrayController<M = {}, CM = {}> extends DynamicController {
  private arrayContext: FormContext<M, FormArray>;
  private subscriptions: Subscription[] = [];
  private renderer: ArrayRenderer;

  constructor(private parentFieldFactory: ParentFieldFactory) {
    super();
  }

  public onInit(context: FormContext<M, FormArray>) {
    this.arrayContext = context;
    this.renderer = new ArrayRenderer(this.parentFieldFactory, this.arrayRoot);

    this.paginator.updateTotalSize(this.children.length);
    this.subscriptions.push(this.paginator.onPageEvent().subscribe(event => this.renderPage(event)));
  }

  public get paginator(): Paginator {
    return this.setting.renderStrategy.paginator;
  }

  private get children(): FormContext<CM>[] {
    return this.arrayContext.children as FormContext<CM>[];
  }

  private get formArray(): FormArray {
    return this.arrayContext.formControl;
  }

  private get setting(): ArrayFormFieldSetting<M, CM> {
    return this.arrayContext.setting as ArrayFormFieldSetting<M, CM>;
  }

  private get settings(): FormFieldSettings {
    return this.arrayContext.settings;
  }

  public push(value: any) {
    const newChildContext = this.parentFieldFactory.create({
      setting: this.setting.childSetting,
      settings: this.settings,
      initialValue: value
    });

    this.children.push(newChildContext);
    this.parentFieldFactory.updateChildren(this.arrayContext);
    this.paginator.updateTotalSize(this.children.length);
    this.renderPage();
  }

  public removeAt(index: number): boolean {
    if (index >= this.children.length || index < 0) {
      return false;
    }

    this.children.splice(index, 1);

    this.parentFieldFactory.updateChildren(this.arrayContext);
    this.paginator.updateTotalSize(this.children.length);

    this.renderPage();
    return true;
  }

  protected destory() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private renderPage(pageEvent: PageEvent = this.paginator.currentPage) {
    return this.renderer.render(this.arrayContext, pageEvent);
  }

  private get arrayRoot(): FormRootDirective {
    return (this._componentRef.instance as FormFieldArrayComponent).formRoot;
  }
}
